import { render, staticRenderFns } from "./buyerBillDistribution.vue?vue&type=template&id=6440dad9&"
import script from "./buyerBillDistribution.vue?vue&type=script&lang=js&"
export * from "./buyerBillDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports